import React from 'react';
import CourierContainer from '../containers/CourierContainer';

const CourierPage = () => {
    return (
        <>
            <CourierContainer />
        </>
    );
};

export default CourierContainer;
